const viewScheduleButton = document.querySelector("#view-schedule-button");
const schedule = document.querySelector("#schedule > .container");
let isScrolling = false;

const onScroll = () => {
	const scheduleButtonBottom =
		viewScheduleButton.getBoundingClientRect().bottom;
	const scheduleTop = schedule.getBoundingClientRect().top;

	document.body.classList.toggle(
		"sticky-cta",
		scheduleButtonBottom < 0 && scheduleTop > window.innerHeight && !isScrolling
	);
};

if (viewScheduleButton && schedule) {
	onScroll();
	window.addEventListener("scroll", onScroll);
	for (const link of document.querySelectorAll(".view-schedule-button")) {
		link.addEventListener("click", () => {
			isScrolling = true;
			setTimeout(() => {
				isScrolling = false;
			}, 2000);
		});
	}
}
